<template>
  <display-items namespace="logbook">
    <template v-slot:cards="{ items }">
      <div>
        <entry-card
          class="my-3"
          v-for="entry in items"
          :entry="entry"
          :key="entry.id"
        >
          <template v-slot:default>
            <v-btn
              class="mx-3"
              small
              v-if="isEditMode"
              @click="handleSelectClick(entry)"
            >
              SELECTIONNER
            </v-btn>
          </template>
        </entry-card>
      </div>
    </template>
  </display-items>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { getEventColor, getEventIcon } from '@/business/utils/display';
import EntryCard from '@/components/cards/EntryCard';
import { createNamespacedHelpers } from 'vuex';
import DisplayItems from '@/components/displays/DisplayItems';

const { mapGetters, mapActions } = createNamespacedHelpers('logbook');

export default {
  name: 'Logbook',
  components: { EntryCard, DisplayItems },
  computed: {
    ...mapGetters({
      isEditMode: 'isEditMode',
    }),
  },
  methods: {
    ...mapActions(['setSelectedItems', 'toogleEditMode']),
    generateMessage,
    getEventColor,
    getEventIcon,
    handleSelectClick(entry) {
      this.setSelectedItems([entry.id]);
      this.$emit('itemSelected', entry);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
